/**
 * Constante des locales supportées, avec typage fort.
 */
export const Locales = {
  FRENCH: "fr",
  ENGLISH: "en",
} as const;

// Type permettant d'obtenir "fr" | "en"
export type LocaleCode = typeof Locales[keyof typeof Locales];
